import camelcaseKeys from 'camelcase-keys';
import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import AgendaAPI from '../../api/agenda';
import { throwErrorMessage } from '../utils/api';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
    isCompleting: false,
  },
};

export const getters = {
  getAgendaEvents($state) {
    return [...$state.records].sort(
      (eventA, eventB) =>
        new Date(eventA.scheduledAt).getTime() -
        new Date(eventB.scheduledAt).getTime()
    );
  },
  getAgendaEvent: $state => id =>
    $state.records.find(record => record.id === Number(id)),
  getUIFlags($state) {
    return $state.uiFlags;
  },
};

export const actions = {
  async get({ commit }) {
    commit(types.SET_AGENDA_UI_FLAG, { isFetching: true });
    try {
      const response = await AgendaAPI.get();
      commit(
        types.SET_AGENDA_EVENTS,
        camelcaseKeys(response.data.payload, { deep: true })
      );
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit(types.SET_AGENDA_UI_FLAG, { isFetching: false });
    }
  },
  async create({ commit }, agendaEvent) {
    commit(types.SET_AGENDA_UI_FLAG, { isCreating: true });
    try {
      const response = await AgendaAPI.create({ agenda_event: agendaEvent });
      commit(
        types.ADD_AGENDA_EVENT,
        camelcaseKeys(response.data.payload, { deep: true })
      );
    } catch (error) {
      throwErrorMessage(error);
      throw error;
    } finally {
      commit(types.SET_AGENDA_UI_FLAG, { isCreating: false });
    }
  },
  async update({ commit }, { id, ...agendaEvent }) {
    commit(types.SET_AGENDA_UI_FLAG, { isUpdating: true });
    try {
      const response = await AgendaAPI.update(id, { agenda_event: agendaEvent });
      commit(
        types.EDIT_AGENDA_EVENT,
        camelcaseKeys(response.data.payload, { deep: true })
      );
    } catch (error) {
      throwErrorMessage(error);
      throw error;
    } finally {
      commit(types.SET_AGENDA_UI_FLAG, { isUpdating: false });
    }
  },
  async complete({ commit }, id) {
    commit(types.SET_AGENDA_UI_FLAG, { isCompleting: true });
    try {
      const response = await AgendaAPI.complete(id);
      commit(
        types.EDIT_AGENDA_EVENT,
        camelcaseKeys(response.data.payload, { deep: true })
      );
    } catch (error) {
      throwErrorMessage(error);
      throw error;
    } finally {
      commit(types.SET_AGENDA_UI_FLAG, { isCompleting: false });
    }
  },
  async delete({ commit }, id) {
    commit(types.SET_AGENDA_UI_FLAG, { isDeleting: true });
    try {
      await AgendaAPI.delete(id);
      commit(types.DELETE_AGENDA_EVENT, id);
    } catch (error) {
      throwErrorMessage(error);
      throw error;
    } finally {
      commit(types.SET_AGENDA_UI_FLAG, { isDeleting: false });
    }
  },
};

export const mutations = {
  [types.SET_AGENDA_UI_FLAG]($state, data) {
    $state.uiFlags = {
      ...$state.uiFlags,
      ...data,
    };
  },
  [types.SET_AGENDA_EVENTS]: MutationHelpers.set,
  [types.ADD_AGENDA_EVENT]: MutationHelpers.setSingleRecord,
  [types.EDIT_AGENDA_EVENT]: MutationHelpers.update,
  [types.DELETE_AGENDA_EVENT]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
